// extracted by mini-css-extract-plugin
export default {"row":"LoadingPage_row__5L9oh","wrapperPageLoading":"LoadingPage_wrapperPageLoading__c-C4g"};